const useIsMobile = () => {
  const isMobileQuery = window.matchMedia('(max-width: 992px)');

  const updateIsMobile = () => {
    return isMobileQuery.matches;
  };

  let isMobile = updateIsMobile();

  isMobileQuery.addListener(() => {
    isMobile = updateIsMobile();
  });

  return isMobile;
};

export default useIsMobile;
